import Loadable, { NullLoader } from '@comeon/loadable';
import { CasinoRecommendationsKey } from './casino-recommended-constants';
import { RecommendedGame } from './casino-recommended-types';

const RecommendedGamesCarouselAsync = Loadable<{
	recommendationsKey: CasinoRecommendationsKey;
	isLoading: boolean;
	recommendedGames: RecommendedGame[];
	onGameClick?: () => void;
}>({
	loader: () =>
		import(
			/* webpackChunkName: "recommended-games-carousel" */
			'./casino-recommended-carousel'
		),
	loading: NullLoader
});

export default RecommendedGamesCarouselAsync;
